import { render, staticRenderFns } from "./HookRowV2.vue?vue&type=template&id=3fcdcf0f&scoped=true"
import script from "./HookRowV2.vue?vue&type=script&lang=js"
export * from "./HookRowV2.vue?vue&type=script&lang=js"
import style0 from "./HookRowV2.vue?vue&type=style&index=0&id=3fcdcf0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcdcf0f",
  null
  
)

export default component.exports